import { paragraphElementType } from "./ParagraphElement.js";
const paragraphToolbarButton = {
  elementType: paragraphElementType,
  blueprintIcon: "paragraph",
  label: "Paragraph",
  title: "Paragraph",
  suchThat: { isNumbered: false }
};
const paragraphNumberedToolbarButton = {
  elementType: paragraphElementType,
  contemberIcon: "paragraphNumbered",
  label: "Numbered paragraph",
  title: "Numbered paragraph",
  suchThat: { isNumbered: true }
};
export {
  paragraphNumberedToolbarButton,
  paragraphToolbarButton
};
//# sourceMappingURL=paragraphToolbarButtons.js.map
